import { render, staticRenderFns } from "./setScanTemplate.vue?vue&type=template&id=5455a5c7&scoped=true&"
import script from "./setScanTemplate.vue?vue&type=script&lang=js&"
export * from "./setScanTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5455a5c7",
  null
  
)

export default component.exports